import React from "react";
import { compose, withAppContext, withActions } from "containers/HOC";
import { Form, Field } from "react-final-form";
import arrayMutators from "final-form-arrays";
import * as FormUtils from "common/FormUtils";
import * as domain from "common/domain";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import CheckboxPack from "components/CheckboxPack";
import InputPack from "components/InputPack";
import BlockSelector from "components/new/BlockSelector";
import MonthSelector from "./MonthSelector";
import { closeModal } from "containers/App/_actions";

class BlockLevelApplicationModal extends React.Component {
    validate = (viewModel) => {
        const error = {};

        if (!viewModel.blockIds || viewModel.blockIds.length === 0) error.blockIds = "Required";

        return error;
    };

    submit = (viewModel) => {
        delete viewModel.availableBlocks;
        this.props.modal.onConfirm(viewModel);
        this.props.closeModal();
    };

    render() {
        const { viewModel } = this.props;

        return (
            <Form initialValues={viewModel} mutators={{ ...arrayMutators }} validate={this.validate} onSubmit={this.submit}>
                {({ form, values, handleSubmit, submitting, submitSucceeded }) => {
                    const disableSave = submitSucceeded || submitting;

                    const monthsFieldName = `months`;
                    const monthsFieldState = form.getFieldState(monthsFieldName);
                    const monthsAreInvalid = monthsFieldState && monthsFieldState.touched && (monthsFieldState.error || []).length > 0;

                    return (
                        <Modal title="DCD application - by blocks" allowOffline={true}>
                            {({ closeModal }) => (
                                <form onSubmit={handleSubmit}>
                                    <ModalBody>
                                        <Grid>
                                            <GridCell>
                                                <Field name="blockIds" component={BlockSelector} availableBlocks={viewModel.availableBlocks} />
                                            </GridCell>
                                            <GridCell>
                                                <h3>Application months</h3>
                                                <p className="u-mt-md">DCD can be applied up to 3 times per year. Typically, DCD is applied twice per year in April/May and July/August or March and April/May in Southland when grazing off in winter occurs."</p>
                                                <div className="FarmTable-supplementary u-mt-md">
                                                    <div className="Table">
                                                        <table>
                                                            <thead>
                                                                <tr className="Calendar-months1">
                                                                    {domain.farmYear.map((month) => (
                                                                        <th className="Calendar-month1 u-textCenter" key={month}>
                                                                            {month.substring(0, 3)}
                                                                        </th>
                                                                    ))}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr className={monthsAreInvalid ? "In-error" : ""}>
                                                                    <MonthSelector form={form} monthsFieldName={monthsFieldName} />
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </GridCell>
                                            <GridCell>
                                                <Field name="nFertiliserAppliedWithinSevenDays" type="Checkbox" component={CheckboxPack} label="N fertiliser applied in the same month as DCD is applied within 7 days of the DCD application" />
                                            </GridCell>
                                            {viewModel.longTermFactor !== 100 && (
                                                <GridCell className="u-width1of5">
                                                    <Field name="longTermFactor" type="text" label="DCD long term factor" uom="%" placeholder="0" component={InputPack} format={FormUtils.formatters.formatInt} formatOnBlur />
                                                </GridCell>
                                            )}
                                        </Grid>
                                    </ModalBody>
                                    <ModalFooter>
                                        <div className="ButtonBar">
                                            <div className="ButtonBar-left">
                                                <button id="cancel-button" type="button" className="Button Button--secondary" onClick={closeModal}>
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button id="save-button" type="submit" className="Button" disabled={disableSave}>
                                                    Done
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </form>
                            )}
                        </Modal>
                    );
                }}
            </Form>
        );
    }
}
export default compose(withAppContext, withActions({ closeModal }))(BlockLevelApplicationModal);
